import * as React from 'react';
import { FooterLinksModel } from '../';
import { FooterLinkListItem } from '../FooterLinkListItem';
import './style.css';

export interface FooterLinkListProps {
  links: FooterLinksModel;
}

export interface FooterLinkListState {
  /* empty */
}

export interface Link {
  icon?: string;
  text: string;
  url: string;
}

export class FooterLinkList extends React.Component<
  FooterLinkListProps,
  FooterLinkListState
> {
  render() {
    const { links: { className, links, title } } = this.props;

    return (
      <div
        className={
          'footer-links-section footer-links-list-wrapper ' + className
        }
      >
        <h4 className="footer-links-list-header">{title}</h4>
        <ul className="footer-links-list">
          {links.map(link => (
            <FooterLinkListItem key={link.title} link={link} />
          ))}
        </ul>
      </div>
    );
  }
}

export default FooterLinkList;



// WEBPACK FOOTER //
// ./src/app/components/App/Footer/FooterLinks/FooterLinkList/index.tsx